"use client";

import * as React from "react";
import {HeroUIProvider} from "@heroui/system";
import {ThemeProvider as NextThemesProvider} from "next-themes";
import {ThemeProviderProps} from "next-themes/dist/types";
import {MonitoringProvider} from "@/components/monitoring";
import { useEffect } from 'react'

export interface ProvidersProps {
    children: React.ReactNode;
    themeProps?: ThemeProviderProps;
}

export function Providers({children, themeProps}: ProvidersProps) {
    useEffect(() => {
    }, []);
    return (<MonitoringProvider>
            <HeroUIProvider className={`h-full`}>
                <NextThemesProvider {...themeProps}>{children}</NextThemesProvider>
            </HeroUIProvider></MonitoringProvider>
    );
}
